module.exports = __webpack_public_path__ + "7fee1e7fc73577f180feca1ead34a780.svg";